// extracted by mini-css-extract-plugin
export default {"verifyContainer":"Verify_verifyContainer__t3mPM","input":"Verify_input__Hhe1J","button":"Verify_button__ZLuVJ","error":"Verify_error__fe7td"};